import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RegisterComponent } from './register/register.component';
import { RegisterCompleteComponent } from './register-complete/register-complete.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SelectSubdomainComponent } from './select-subdomain/select-subdomain.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { environment, facebookProvider, googleProvider } from '../environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { InviteUserComponent } from './invite-user/invite-user.component';
import { FacebookModule } from 'ngx-facebook';
import { MatSelectModule } from '@angular/material/select';
import { FbMessengerComponent } from './components/fb-messenger/fb-messenger.component';
import {
	FacebookLoginProvider,
	SocialAuthServiceConfig,
	SocialLoginModule,
	GoogleLoginProvider,
	GoogleSigninButtonModule,
} from '@abacritt/angularx-social-login';
import { AuthStore } from '@biz-store/auth/auth.store';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BaseUiModule } from '@biz-ui/base-ui.module';
import { MatDialogModule } from '@angular/material/dialog';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { translationConfig } from './translate';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { CustomSnackbarModule } from '@biz-ui/shared-presenters/custom-snackbar/custom-snackbar.module';
import { MatStepperModule } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { ReferrerDialogComponent } from './register/referrer-dialog/referrer-dialog.component';
import { GraphQLModule } from './graphql.module';

@NgModule({
	declarations: [
		AppComponent,
		RegisterComponent,
		RegisterCompleteComponent,
		LoginComponent,
		ForgotPasswordComponent,
		ResetPasswordComponent,
		SelectSubdomainComponent,
		InviteUserComponent,
		FbMessengerComponent,
		ReferrerDialogComponent,
	],
	imports: [
		MatProgressBarModule,
		MatRadioModule,
		MatFormFieldModule,
		MatInputModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		HttpClientModule,
		StoreModule.forRoot({
			router: routerReducer,
		}),
		StoreRouterConnectingModule.forRoot(),
		EffectsModule.forRoot([]),
		environment.production == false ? StoreDevtoolsModule.instrument() : [],
		TranslateModule.forRoot(translationConfig),
		SocialLoginModule,
		MatSnackBarModule,
		// FacebookModule.forRoot(),
		MatDialogModule,
		MatSelectModule,
		FacebookModule.forRoot(),
		BaseUiModule,
		MatMenuModule,
		MatDividerModule,
		CustomSnackbarModule,
		AuthStore,
		GoogleSigninButtonModule,
		MatStepperModule,
		GraphQLModule,
	],
	providers: [
		{ provide: Window, useValue: window },
		{
			provide: STEPPER_GLOBAL_OPTIONS,
			useValue: { displayDefaultIndicatorType: false },
		},
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: { appearance: 'outline', floatLabel: 'always' },
		},
		{
			provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
			useValue: { horizontalPosition: 'start', verticalPosition: 'bottom', panelClass: 'bg-danger' },
		},
		{
			provide: 'SocialAuthServiceConfig',
			useValue: {
				autoLogin: false,
				providers: [
					{
						id: GoogleLoginProvider.PROVIDER_ID,
						provider: new GoogleLoginProvider(googleProvider),
					},
					{
						id: FacebookLoginProvider.PROVIDER_ID,
						provider: new FacebookLoginProvider(facebookProvider),
					},
				],
			} as SocialAuthServiceConfig,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
